export default {
  helpful: {
    en: 'Helpful?',
  },
  helpfulLong: {
    en: 'Was this review helpful?',
  },
}
